export var EscalationTableFields;
(function (EscalationTableFields) {
    EscalationTableFields["Type"] = "type";
    EscalationTableFields["PolicyName"] = "policyName";
    EscalationTableFields["ContactName"] = "contactName";
    EscalationTableFields["InvoiceNumber"] = "invoiceNumber";
    EscalationTableFields["InvoiceReference"] = "invoiceReference";
    EscalationTableFields["InvoiceDate"] = "invoiceDate";
    EscalationTableFields["InvoiceDueDate"] = "invoiceDueDate";
    EscalationTableFields["DaysPastDue"] = "daysPastDue";
    EscalationTableFields["ExpectedPaymentDate"] = "expectedPaymentDate";
    EscalationTableFields["AmountPaid"] = "amountPaid";
    EscalationTableFields["BalanceDue"] = "balanceDue";
    EscalationTableFields["ContactBalance"] = "contactBalance";
    EscalationTableFields["Status"] = "status";
    EscalationTableFields["ScheduledDate"] = "scheduledDate";
    EscalationTableFields["LatestNote"] = "latestNote";
    EscalationTableFields["Assignee"] = "assignee";
    EscalationTableFields["GroupId"] = "groupId";
    EscalationTableFields["ContactTag"] = "contactTag";
    EscalationTableFields["InvoiceTag"] = "invoiceTag";
    EscalationTableFields["Frozen"] = "frozen";
    // Hidden
    EscalationTableFields["Paid"] = "paid";
    EscalationTableFields["AssignedUserId"] = "assignedUserId";
})(EscalationTableFields || (EscalationTableFields = {}));
export var EscalationStatus;
(function (EscalationStatus) {
    EscalationStatus["PENDING"] = "pending";
    EscalationStatus["COMPLETE"] = "complete";
    EscalationStatus["CANCELLED"] = "cancelled";
})(EscalationStatus || (EscalationStatus = {}));
export var IEscalationOutcome;
(function (IEscalationOutcome) {
    IEscalationOutcome["NO_RESPONSE"] = "NO_RESPONSE";
    IEscalationOutcome["LEFT_MESSAGE"] = "LEFT_MESSAGE";
    IEscalationOutcome["SPOKE_TO_CUSTOMER"] = "SPOKE_TO_CUSTOMER";
    IEscalationOutcome["SET_EXPECTED_PAYMENT_DATE"] = "SET_EXPECTED_PAYMENT_DATE";
    IEscalationOutcome["PAYMENT_PROMISE"] = "PAYMENT_PROMISE";
    IEscalationOutcome["QUERY_RAISED"] = "QUERY_RAISED";
})(IEscalationOutcome || (IEscalationOutcome = {}));
export const EscalationOutcomeLabels = {
    [IEscalationOutcome.NO_RESPONSE]: `No response`,
    [IEscalationOutcome.LEFT_MESSAGE]: `Left a message`,
    [IEscalationOutcome.SPOKE_TO_CUSTOMER]: `Spoke to customer`,
    [IEscalationOutcome.SET_EXPECTED_PAYMENT_DATE]: `Set expected payment date`,
    [IEscalationOutcome.PAYMENT_PROMISE]: `Customer promised to pay`,
    [IEscalationOutcome.QUERY_RAISED]: `Customer raised a query`,
};
//# sourceMappingURL=escalation.js.map